<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Edit Category</div>
    </div>
    <div class="white-wrapper" style="zoom: 0.9">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="category_name"
                type="text"
                name="category_name"
                id="category_name"
              />
              <label>Category Name</label>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="category_is_active"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="billing-categories"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      category_name: "",
      category_is_active: "Y",
      category_id: null,
      submitted: false,
    };
  },
  mounted() {},
  beforeMount() {
    const { category_id } = this.$route.query;
    if (category_id) {
      this.category_id = category_id;
      this.getCategoryDetails(category_id);
    }
  },
  methods: {
    getCategoryDetails(category_id) {
      let payload = {
        category_id: category_id,
      };
      MasterService.GetSingleManualBiilingCategory(payload).then((response) => {
        const { data } = response;
        if (data && data.status && data.Records && data.Records.length > 0) {
          this.category_name = data.Records[0].category_name;
          this.category_is_active = data.Records[0].category_is_active || "Y";
          this.category_id = data.Records[0].category_id;
        } else {
          this.$toasted.show(data.message || "Unable to fetch data");
        }
      });
    },
    OnFinalSubmit: function () {
      this.submitted = true;
      if (!this.category_name) {
        return this.$toasted.show("Please Enter Category Name");
      } else {
        let payload = {
          category_id: this.category_id,
          category_name: this.category_name,
          category_is_active: this.category_is_active || "Y",
        };
        MasterService.UpdateManualBiilingCategory(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              this.resetForm();
              this.$router.push({
                path: "billing-categories",
              });
              this.submitted = false;
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      }
    },
    resetForm: function () {
      this.category_name = "";
      this.category_is_active = "Y";
      this.btenable = false;
      this.submitted = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ManualBillingComponents/editManualBillingCategories.vue